export const upcomingDateFormatted = (validFromFormatted: string): [string, string] => {
    const date = validFromFormatted.match(/([0-3]?[0-9])\s\w+/);

    if (date) {
        const splittedDate = date[0].split(' ');

        return [splittedDate[0], splittedDate[1]];
    }

    const day = validFromFormatted.match(/^([A-ö\w-]+)/)[0];
    const time = validFromFormatted.match(/([0-1]?[0-9]|2[0-3]):[0-5][0-9]/)[0];

    return [day, time];
};
